import {useRef, useState} from 'react';

// Solves the «stale closure» problem

export default function useStateReference(value) {
    const ref = useRef(value);
    const [, forceRender] = useState(false);
  
    function updateState(newState) {
      if (!Object.is(ref.current, newState)) {
        ref.current = newState;
        forceRender(s => !s);
      }
    }
  
    return [ref, updateState];
  }
